/**
 * DashboardCustomizePage — Stream D (Paritaet R4)
 *
 * Eigene Seite /dashboard/customize als 1:1-Pendant zu v1 /dashboard_boxes
 * (Legacy-URL leitet dorthin um, siehe routes/dashboard_boxes.tsx).
 *
 * Free-User: volle Liste sichtbar, Upsell-Panel, Speichern deaktiviert.
 * Premium: Toggles + Reihenfolge, expliziter Speichern-Button
 * (autoSave ist hier aus, damit die Seite ein klares "Update Dashboard" hat).
 */
import { useTranslation } from 'react-i18next'
import { Link, useSearch } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useDashboardLayout } from './useDashboardLayout'
import { WidgetLayoutEditor } from './WidgetLayoutEditor'

export function DashboardCustomizePage() {
  const { t } = useTranslation('dashboard')
  // R5/Stream TD: Der Tag-Scope wird hier nur durchgereicht — das Layout gilt
  // fuer alle Scopes (v1: users.dashboard_layout). `strict: false` haelt die
  // Seite auch dann lauffaehig, wenn sie ausserhalb ihrer Route gerendert wird.
  const search = (useSearch({ strict: false }) ?? {}) as { tag?: number }
  const tagId = search.tag ?? null
  const {
    layout,
    meta,
    isLoading,
    toggleWidget,
    reorderWidgets,
    resetLayout,
    saveLayout,
    isSaving,
    saveError,
    saveSucceeded,
    isDirty,
  } = useDashboardLayout({ autoSave: false })

  return (
    <div className="dashboard-customize-page" style={{ maxWidth: 640, margin: '0 auto' }}>
      <div className="customizer-header">
        <h1 style={{ fontSize: 20, margin: 0 }}>{t('customizer.pageTitle')}</h1>
        <Link to="/dashboard" search={tagId ? { tag: tagId } : {}} className="reset-btn">
          <ArrowLeft size={14} />
          {t('customizer.backToDashboard')}
        </Link>
      </div>

      <p className="muted">{t('customizer.pageIntro')}</p>
      <p className="muted" style={{ fontSize: 12 }}>{t('customizer.tagScopeHint')}</p>

      {isLoading ? (
        <div className="layout-loading">{t('layout.loadingLayout')}</div>
      ) : (
        <WidgetLayoutEditor
          layout={layout}
          meta={meta}
          onToggle={toggleWidget}
          onReorder={reorderWidgets}
          onReset={resetLayout}
          onSave={saveLayout}
          isSaving={isSaving}
          isDirty={isDirty}
          saveError={saveError}
          saveSucceeded={saveSucceeded}
        />
      )}
    </div>
  )
}
